var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({ width: _vm.window_width })},[_c('img',{attrs:{"src":require("../assets/mark.jpg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }